import React from 'react';
import {
  Button,
  ButtonSize,
  SymbolDirection,
  ButtonIconSize,
  ButtonVariant,
  ButtonColor,
  ButtonProps,
  ICON_CHEVRON,
} from '@doveit/lego';
import * as styles from './BackBar.style';

export type BackBarProps = React.PropsWithChildren<{
  backButton: ButtonProps,
}>;

const BackBar: React.FC<BackBarProps> = ({
  backButton,
  children,
}) => (
  <div css={styles.base}>
    <Button
      {...backButton}
      dataRef="back-to-serp"
      size={ButtonSize.SMALL}
      icon={ICON_CHEVRON}
      iconDirection={SymbolDirection.LEFT}
      iconSize={ButtonIconSize.LARGE}
      variant={ButtonVariant.LIGHT}
      color={ButtonColor.DARK}
      autoWidth
    />
    {children && (
      <div
        css={styles.sideBox}
        data-ref="backbar-side-box"
      >
        {children}
      </div>
    )}
  </div>
);

export default BackBar;
